import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export const useCatalogueSearchResultFooterCta = () => {
  const keyPrefix = 'Chat.tools.searchCatalogue';
  const i18nKey = 'resultFooter';
  const { t, i18n } = useTranslation(I18nNamespace.intake, { keyPrefix });
  const hasFooter = i18n.exists(`${keyPrefix}.${i18nKey}`, { ns: I18nNamespace.intake });

  return {
    t,
    i18nKey,
    hasFooter,
  };
};
